<template>
  <div id="bindingTerminal">
    <!-- 搜索栏 -->
    <div class="search-box">
      <div>
        <Input v-model="searchValue" prefix="ios-search-outline" placeholder="请输入用户"
          style="width: 208px; margin-right: 10px;" clearable @on-enter="handleSearchClick"
          @on-clear="handleSearchClick" />
        <Button class="ys-confirm" @click="handleSearchClick">搜索</Button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table :columns="Columns" :tableData="tableData" :loading="tableLoading" :tableHeight="tableHeight"
      @on-btn-click="onBtnClick">
    </el-table>
    <!-- 分页 -->
    <div class="paging-box">
      <Page :total="totalCount" :page-size="12" :current="page" @on-change="handlePagingClick" />
    </div>
    <div>
      <Alter ref="alterModal" :configData="configData" @change_ok="confirmDel"></Alter>
    </div>
  </div>
</template>
<script>
  import {
    mapActions
  } from "vuex"
  import elementResizeDetectorMaker from "element-resize-detector"; // 获取元素的高度
  import ElTable from '_g/commonComponent/table/elTable.vue';
  import Columns from './tableConfig.js'
  export default {
    components: {
      'el-table': ElTable,
    },
    data() {
      return {
        tableData: [
          {
            user_id: '超级',
            user_cn_name: '1233423',
            phone_no: '填空',
            ent_name: '巨额鬼',
            dept_cn_name: '范德萨发生的 '
          }
        ], // 数据
        Columns: [], // 表头
        totalCount: 0, // 总条数
        tableHeight: 0,
        searchValue: '', // 搜索框的值
        page: 1, // 当前页
        configData: {}, // 弹框配置信息
        user_id: '', // 列表出删除用户的id
        editId: '', // 编辑用到的id
        selNowEnterId: "", // 当前选择的企业ID
        // 权限配置相关变量
        explainInfo: {}, // 权限配置弹框头部基础信息
        MenuPermissionList: [], // 菜单权限数据列表
        BtnPermissionList: [], //按钮权限列表
        currentStatus: false, // 打开权限列表弹框
        departmentList: [], //部门列表
        departmentId: '',
        tableLoading: true, // 表格loading
        userConfig: null
      }
    },
    methods: {
      ...mapActions([
        "us_PageUserTermAction", // 列表
        "us_UpdateUserTermUseStateAction", // 启用
        "us_DeleteUserTermAction", // 删除
      ]),
      // 获取元素的高度
      getElementHeight() {
        let ERD = elementResizeDetectorMaker();
        let _this = this;
        ERD.listenTo(document.getElementById("bindingTerminal"), (element) => {
          _this.tableHeight = (element.offsetHeight - 66 - 60 - 20); // 在该基础上多-20跟分页有间距
        });
      },
      // 操作按钮
      onBtnClick(rowItem, options) {
        console.log(rowItem, options);
        this.userConfig = rowItem;
        switch (options.code) {
          case "start":
            this.us_UpdateUserTermUseStateActions();
            break;
          case "end":
            this.DeleteComponent();
            break;
          default:
            break;
        }
      },
      // 搜索功能
      handleSearchClick() {
        this.page = 1;
        // 获取列表
        this.us_PageUserTermActions();
      },
      // 分页功能
      handlePagingClick(res) {
        this.page = res;
        // 获取列表
        this.us_PageUserTermActions();
      },
      confirmDel() {
        this.us_DeleteUserTermActions();
      },
      // 删除
      DeleteComponent(item) {
        this.configData = {
          type: "warning",
          title: "警告",
          content: "是否删除当前信息"
        };
        this.$refs.alterModal.OpenModal();
      },
      // 获取列表数据
      async us_PageUserTermActions() {
        this.tableData = [];
        this.tableLoading = true;
        try {
          const data = await this.us_PageUserTermAction(
            {
              user_cn_name: this.searchValue || '', // 用户名查询
              start_recd: (this.page - 1) * 12,
              limit_recd: 12,
            }
          );
          if (data.request_state) {
            this.totalCount = data.all_recd;
            this.tableData = data.term_list;
            this.tableLoading = false;
          }
        } catch (error) {
          console.log(error);
        }
      },
      // 启用
      async us_UpdateUserTermUseStateActions() {
        try {
          const data = await this.us_UpdateUserTermUseStateAction({
            user_id: this.userConfig.user_id,
            term_no: this.userConfig.term_no
          });
          if (data.request_state) {
            this.$Message.success('启用成功~~');
            // 刷新页面
            this.us_PageUserTermActions();
          }
        } catch (error) {
          console.log(error);
        }
      },
      // 删除
      async us_DeleteUserTermActions() {
        try {
          const data = await this.us_DeleteUserTermAction({
            user_id: this.userConfig.user_id,
            term_no: this.userConfig.term_no
          });
          if (data.request_state) {
            this.$Message.success('删除成功~~');
            // 刷新页面
            this.us_PageUserTermActions();
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    mounted() {
      this.Columns = Columns;
      // 获取元素高度
      this.getElementHeight();
      // 获取列表数据
      this.us_PageUserTermActions();
    },
  }
</script>
<style lang="less" scoped>
  #bindingTerminal {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0 50px;
    box-sizing: border-box;
    overflow: hidden;

    .search-box {
      width: 100%;
      height: 66px;
      padding: 22px 0px 12px 0px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
    }

    .paging-box {
      position: fixed;
      bottom: 0px;
      right: 50px;
      z-index: 1;
      height: 60px;
      width: calc(100% - 250);
      text-align: right;
    }
  }
</style>